import React from "react";
import { Dropdown, Menu, message, Tooltip } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { printBonpdf } from "../Services/PrintBonService";



const BonPdf = ({numba}) => {
  const exportToPDF = () => {
    printBonpdf(numba);
    message.success("Impression Réussi !")
  };

  const handleExport = () => {
    exportToPDF();
  };

 
  return (
    <Tooltip  title="pdf">
      <PrinterOutlined  onClick={handleExport} size="small" style={{ cursor: 'pointer', color: '#67f02e', marginRight: 8 }}  />
    </Tooltip>
  );
};

export default BonPdf;